import createComponent from '@carvana/merch-components/createComponent';

export const SectionHeading = createComponent('h2', {
  className: 't-heading-xl text-text-strong px-2xl'
});

export const SectionWrapper = createComponent('section', {
  className:
    'flex flex-col gap-3xl py-3xl md:border-t md:border-border-subtle md:pt-5xl'
});
